// dataProcessor.js  
  
export const processResponseData = (rawData) => {  
    const processedData = [];  
    const searchResult = rawData?.pdcPractitionerOrganizationSearch;  
    if (!searchResult) return processedData;  
    
    const entries = searchResult?.entry || [];  
    const llmResponse = searchResult?.llmSearchResponse || '';  
    
    entries?.forEach((item, count) => {  
      const resource = item?.resource;  
      let row = {  
        RequestID: count + 1,  
        Id: resource?.id || '',  
        providerId: '',  
        provname: '',  
        provgender: '',  
        addressLine1: '',  
        city: '',  
        state: '',  
        zipCode: '',  
        distance: '',  
        spclTypCd: '',  
        hgScore: '',  
        costEffRating: '',  
        qualtyOutComeTyCd: '',  
        effOutcomeTyCd: '',  
        tierLevel: '',  
        diagnosisCd: '',  
        visits: '',  
        lat: '',  
        long: '',  
        llmValue: llmResponse,  
        elasticScrTotal: '',  
        scoreQuality: '',  
        scoreBenefits: '',  
        scoreConvenience: '',  
        dataAccuracyScore: '',  
        premiumDesgRecom: '',  
        costEfficiencyAG: '',  
        tiering: '',  
        acoAffiliation: '',  
        preferdProviderRecom: '',  
        costIndRecom: '',  
        eveAppointment: '',  
        weekendAppointment: '',  
        anp: '',  
        onlineAppSched: '',  
        virtual: '',  
        language: '',  
        gender: '',  
        boardCertified: '',  
        education: '',  
        consumerRating: '',  
        trustEvaluator: '',  
        randomization: '',  
        appAvailWindow: '',  
        personalFitScore: ''  
      };  
    
      if (resource?.resourceType === 'PractitionerRole') {  
        const identifier = resource?.identifier || [];  
        const extension = resource?.extension || [];  
        identifier?.forEach(id => {  
          if (id?.type?.text === 'Distance') {  
            row.distance = id?.value;  
          }  
          if (id?.type?.text === 'ProviderID') {  
            row.providerId = id?.value;  
          }  
        });  
    
        if (resource?.practitioner && resource?.practitioner?.reference) {  
          const practitionerRef = resource.practitioner.reference?.split('/')[1];  
          const practitioner = entries?.find(d => d?.resource?.id === practitionerRef);  
    
          if (practitioner) {  
            row.providerId = practitioner?.resource?.id;  
            row.provname = practitioner?.resource?.practitionerName?.[0]?.text || '';  
            row.provgender = practitioner?.resource?.gender || '';  
            row.hgScore = practitioner?.resource?.extension?.find(ext => ext.url === 'http://pesid.org/StructureDefinition/health-grade-ratings')?.extension?.find(innerExt => innerExt.url === 'score')?.valueString || ' ';  
          }  
        }  
    
        if (resource?.organization && resource?.organization?.reference) {  
          const organizationRef = resource.organization.reference?.split('/')[1];  
          const organization = entries?.find(d => d?.resource?.id === organizationRef);  
    
          if (organization) {  
            row.providerId = organization?.resource?.id || '';  
            row.provname = organization?.resource?.name || '';  
          }  
        }  
    
        if (resource?.location && resource?.location?.[0] && resource?.location?.[0]?.reference) {  
          const locationRef = resource?.location?.[0]?.reference.split('/')?.[1];  
          const location = entries?.find(d => d?.resource?.id === locationRef && d?.resource?.resourceType === 'Location');  
    
          if (location) {  
            const address = location?.resource?.address || {};  
            row.addressLine1 = address?.line?.[0] || '';  
            row.city = address?.city || '';  
            row.state = address?.state || '';  
            row.zipCode = address?.postalCode || '';  
            row.lat = location?.resource?.position?.latitude || '';  
            row.long = location?.resource?.position?.longitude || '';  
          }  
        }  
    
        extension?.forEach(ext => {  
          ext?.extension?.forEach(innerExt => {  
            switch (innerExt.url) {  
              case 'spclTypCode':  
                row.spclTypCd += innerExt.valueCodeableConcept?.coding?.[0]?.code + '-' + innerExt.valueCodeableConcept?.coding?.[0]?.display + ', ';  
                break;  
              case 'affinity':  
                row.visits = innerExt.valueString || '';  
                break;  
              case 'diagnosisCode':  
                row.diagnosisCd = innerExt.valueString || '';  
                break;  
              case 'costEfficiencyRating':  
                row.costEffRating = innerExt.valueString || '';  
                break;  
              case 'qualityOutComeTypeCode':  
                row.qualtyOutComeTyCd = innerExt.valueCodeableConcept?.coding?.[0].code || '';  
                break;  
              case 'efficiencyOutcomeTypeCode':  
                row.effOutcomeTyCd = innerExt.valueCodeableConcept?.coding?.[0]?.code || '';  
                break;  
              case 'tierLevel':  
                row.tierLevel = innerExt.valueString || '';  
                break;  
              case 'elasticScoreTotal':  
                row.elasticScrTotal = innerExt.valueString || '';  
                break;  
              case 'scoreQuality':  
                row.scoreQuality = innerExt.valueString || '';  
                break;  
              case 'scoreBenefits':  
                row.scoreBenefits = innerExt.valueString || '';  
                break;  
              case 'scoreConvenience':  
                row.scoreConvenience = innerExt.valueString || '';  
                break;  
              case 'dataAccuracyScore':  
                row.dataAccuracyScore = innerExt.valueString || '';  
                break;  
              case 'premiumDesignationRecommendation':  
                row.premiumDesgRecom = innerExt.valueString || '';  
                break;  
              case 'costEfficiencyAG':  
                row.costEfficiencyAG = innerExt.valueString || '';  
                break;  
              case 'tiering':  
                row.tiering = innerExt.valueString || '';  
                break;  
              case 'acoAffiliation':  
                row.acoAffiliation = innerExt.valueString || '';  
                break;  
              case 'preferredProviderRecommendation':  
                row.preferdProviderRecom = innerExt.valueString || '';  
                break;  
              case 'costIndicatorRecommendation':  
                row.costIndRecom = innerExt.valueString || '';  
                break;  
              case 'eveningAppointments':  
                row.eveAppointment = innerExt.valueString || '';  
                break;  
              case 'weekendAppointments':  
                row.weekendAppointment = innerExt.valueString || '';  
                break;  
              case 'anp':  
                row.anp = innerExt.valueString || '';  
                break;  
              case 'onlineAppointmentScheduling':  
                row.onlineAppSched = innerExt.valueString || '';  
                break;  
              case 'virtual':  
                row.virtual = innerExt.valueString || '';  
                break;  
              case 'language':  
                row.language = innerExt.valueString || '';  
                break;  
              case 'gender':  
                row.gender = innerExt.valueString || '';  
                break;  
              case 'boardCertified':  
                row.boardCertified = innerExt.valueString || '';  
                break;  
              case 'education':  
                row.education = innerExt.valueString || '';  
                break;  
              case 'consumerRating':  
                row.consumerRating = innerExt.valueString || '';  
                break;  
              case 'trustEvaluator':  
                row.trustEvaluator = innerExt.valueString || '';  
                break;  
              case 'randomization':  
                row.randomization = innerExt.valueString || '';  
                break;  
              case 'appointmentAvailabilityWindow':  
                row.appAvailWindow = innerExt.valueString || '';  
                break;  
              case 'personalFitScore':  
                row.personalFitScore = innerExt.valueString || '';  
                break;  
              default:  
                break;  
            }  
          });  
        });  
      }  
    
      const hasOtherData = Object.keys(row).some(key => key !== 'Id' && key !== 'RequestID' && key !== 'llmValue' && row[key]);  
      if (hasOtherData) {  
        processedData.push(row);  
      }  
    });  
    
    return processedData;  
  };  
  